import type { ReactNode } from 'react'
import { motion, useReducedMotion } from 'framer-motion'
import { useElitePlansLanding } from '../ElitePlansLandingContext'
import {
  ELITE_PLANS_PANEL_ENTER_TRANSITION,
  ELITE_PLANS_PANEL_MOTION_INITIAL,
  ELITE_PLANS_PANEL_REDUCED_MOTION_TRANSITION
} from '../constants/motion'

/** Animated tabpanel body keyed to the active plan (pairs with PlanSwitcher tabs). */
export function ElitePlansTabPanel({ children }: { children: ReactNode }) {
  const { tabPanelId, selectedTabId, activeTab } = useElitePlansLanding()
  const reduceMotion = useReducedMotion()

  return (
    // flex-1 / min-h-0 only take effect when the shell is a column (family landing); no-op otherwise
    <div role='tabpanel' id={tabPanelId} aria-labelledby={selectedTabId} className='flex min-h-0 flex-1 flex-col'>
      <motion.div
        key={activeTab.id}
        className='ep-motion flex min-h-0 w-full flex-1 flex-col'
        initial={reduceMotion ? false : ELITE_PLANS_PANEL_MOTION_INITIAL}
        animate={{ opacity: 1, y: 0 }}
        transition={
          reduceMotion
            ? ELITE_PLANS_PANEL_REDUCED_MOTION_TRANSITION
            : ELITE_PLANS_PANEL_ENTER_TRANSITION
        }
      >
        {children}
      </motion.div>
    </div>
  )
}
